import { _Post } from "../conversations/types.js";
import { addProp } from "@pnp/odata";
import { Attachments } from "./types.js";
addProp(_Post, "attachments", Attachments);
//# sourceMappingURL=conversations.js.map